export default "143baa49822c883a.png"